import React, { Component } from "react";
import { Link } from 'react-router-dom'
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';
import MainLayout from '../mainLayout';
import CheckBox from './../component/CheckBox';
//Loader import
import Loader from "../component/loader";

//Service import
import service from '../services'

//Validation import 
import SimpleReactValidator from 'simple-react-validator';

//moment import 
import moment from 'moment-timezone'

//Redux Connect
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActCreators } from '../redux/bindActionCretor'

//react-paginate import 
import ReactPaginate from "react-paginate";

//sweet alert
import swal from 'sweetalert';

// Images import
import serachIcon from "../assets/images/search.svg";
import edit from "../assets/images/edit.svg";
import lock from "../assets/images/lock.svg";
import lockIcon from "../assets/images/lock-icon.svg";
import LockIcon from "../icons/LockIcon";
import LockCloseIcon from "../icons/LockCloseIcon";
import delet from "../assets/images/delet.svg";
import share from "../assets/images/share.svg";
import hoverIcon from "../assets/images/hover-popup.svg";
import hoverIconActive from "../assets/images/hover-popup-active.svg";
import close from "../assets/images/close.svg";
import RoleResetPopup from "./RoleResetPopup";
import GhostLoginPopup from "./GhostLoginPopup";
import { USER_ROLE, ADMIN_CMA_IDS } from "../cosntants";
let sub;
let CMAListArray = [];

const mapStateToProps = state => ({
    getLoginRole: state.getLoginRole,
    getLoginAdminByID: state.getLoginAdminByID,
    getLoginUser: state.getLoginUser,
    FpgLockeded: state.FpgLockeded,
    getBackToAdminFlag: state.getBackToAdminFlag,
})

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActCreators, dispatch)
};

let roleWiseFilterData = [];
class superAdminAccessMgnt extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: '',
            firstName: '',
            lastName: '',
            allAdmin: '',
            sio: '',
            press: '',
            roleName: '',
            id: '',
            deleteId: '',
            selectedDropdown: '',
            fpgLocked: false,
            FPGtoggle: this.props.FpgLockeded,
            CMA: [],
            cmaTree: [],
            roleType: [
                { value: 'Select an Option', name: 'Select an Option' },
                { value: 'sio', name: 'Industry' },
                { value: 'press', name: 'Press' },
                // { value: 'sundanceCircle', name: 'Sundance Circle' },
                { value: 'general', name: 'General' },
                { value: 'sundanceGuest', name: 'Sundance Guest' },
                // { value: 'artist', name: 'Artist' },
                // { value: 'ticketing', name: 'Ticketing' }
            ],
            getAllDetails: [],
            handleDeleteArray: [],
            createAdminUserPopup: false,
            FPGadminUserPopup: false,
            FPGadminUserBlockPopup: false,
            deleteAdmin: false,
            deleteConfirm: false,
            isBlocked: false,
            isFpg: this.props.FpgLockeded,
            changeTitleName: false,
            loaderFlag: false,
            getTotalDocs: '',
            searchField: '',
            disable: false,


            // pagination variable diclaration start
            offset: 1,
            perPage: 50,
            currentPage: 0,
            // pagination variable diclaration end
            rolesType: [
                { assign: "All", name: "All", value: true },
                { assign: "sio", name: "Industry", value: false },
                { assign: "press", name: "Press", value: false },
                // {assign:"sundanceCircle", name:"Sundance Circle",value:false},
                { assign: 'general', name: 'General', value: false },
                { assign: 'sundanceGuest', name: 'Sundance Guest', value: false },
                // { assign: 'artist', name: 'Artist', value: false },
                // {assign: 'ticketing', name: 'Ticketing', value:false}
            ],
            roleResetPopup:false,
            loginPopup:false,
            isEdited: false,
        };
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            validators: {
                apostrophe: {  // name the rule
                    message: 'Please use a valid name of the :attribute',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^([a-zA-Z ']*)$/i) || validator.helpers.testRegex(val, /^[-a-zA-Z s]+$/i) && params.indexOf(val) === -1
                    },
                    required: true  // optional
                }
            }
        });

        this.apiserve = new service();

    }

    getCurrentFormData = () => {
        return cloneDeep({
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            email: this.state.email,
            selectedDropdown: this.state.selectedDropdown,
            CMA: this.state.CMA,
        });
    }

    markAdminUserEdited = () => {
        if (this.state.initialData) {
            const isDirty = !isEqual(this.state.initialData, this.getCurrentFormData());
            if (this.state.isEdited !== isDirty) {
                this.setState({ isEdited: isDirty });
            }
        }
    }

    updateState = (data, callback) => {
        this.setState(data, () => {
            this.markAdminUserEdited();
            if (callback) callback();
        });
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
        roleWiseFilterData = []
        CMAListArray = []
    }

    // Show Waitlist Management children in sidebar order: "My Waitlists" first, then "Waitlists".
    orderWaitlistChildren = (tree) => {
        var order = [ADMIN_CMA_IDS.WAITLIST_MY_WAITLISTS, ADMIN_CMA_IDS.WAITLIST_LIST];
        var rank = function(child) {
            var index = order.indexOf(Number(child.id));
            return index === -1 ? order.length : index;
        };
        return (tree || []).map(function(parent) {
            if (parent.id != ADMIN_CMA_IDS.WAITLIST || !parent.children) {
                return parent;
            }
            return Object.assign({}, parent, { children: parent.children.slice().sort(function(a, b) { return rank(a) - rank(b); }) });
        });
    };

    buildFlatCMA = (tree) => {
        var flatList = [];
        (tree || []).forEach(function(parent) {
            flatList.push({ access: parent.id, value: false, label: parent.label });
            (parent.children || []).forEach(function(child) {
                flatList.push({ access: child.id, value: false, label: child.label });
            });
        });
        return flatList;
    };

    componentDidMount = async () => {
        const { getLoginAdminByID, getLoginRole } = this.props
        let token = localStorage.getItem('loginToken') ? localStorage.getItem('loginToken') : ''
        if (token) {
            // this.apiserve.sendevent("authentication", { token: token});

        }
        if(getLoginRole?.user?.role !== 'admin'){ 
            this.props.history.push('/admin-dashboard')
        }
        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "admin|getAllAdmin":
                    if (!response.error) {
                        if (this.state.deleteConfirm) {
                            this.handleDeletePopup(response.data.docs)
                        } else {
                            roleWiseFilterData = []
                            this.setState({
                                rolesType: [{ assign: "All", name: "All", value: true },
                                { assign: "sio", name: "Industry", value: false },
                                { assign: "press", name: "Press", value: false },
                                // {assign:"sundanceCircle", name:"Sundance Circle",value:false},
                                { assign: 'general', name: 'General', value: false },
                                { assign: 'sundanceGuest', name: 'Sundance Guest', value: false },
                                // { assign: 'artist', name: 'Artist', value: false }
                                ],
                                getAllDetails: response.data.docs,
                                getTotalDocs: response.data.totalDocs,
                                pageCount: Math.ceil(response.data.totalDocs / this.state.perPage),
                            }, () => {
                                this.setState({ loaderFlag: false })
                            })

                        }
                    } else {
                        if (this.props.getLoginUser.token) {
                            if (getLoginRole && getLoginRole.user && getLoginRole.user.role === 'press' || getLoginRole && getLoginRole.user && getLoginRole.user.role === 'sio' ||
                                getLoginRole && getLoginRole.user && getLoginRole.user.role === 'sundanceCircle' ||
                                getLoginRole && getLoginRole.user && getLoginRole.user.role === 'general' ||
                                getLoginRole && getLoginRole.user && getLoginRole.user.role === 'sundanceGuest' ||
                                getLoginRole && getLoginRole.user && getLoginRole.user.role === 'artist') {
                                this.props.history.push('/admin-dashboard')

                            }
                        }
                        else if (getLoginRole && getLoginRole.user && getLoginRole.user.role === 'partner') {
                            this.props.history.push('/profile-partner-view')
                        }
                        else if (getLoginRole && getLoginRole.user && getLoginRole.user.role === 'satellite') {
                            this.props.history.push('/profile-satellite-view')
                        }
                    }


                    break;
                case "admin|createAdmin":
                    roleWiseFilterData = []
                    if (response.error === true) {
                        this.apiserve.error(response.data.error ? response.data.error : response.data);
                        this.setState({ loaderFlag: false });
                    } else {
                        this.getAllAdminView(this.state.offset, this.state.perPage);
                        this.clearFn();
                        this.validator.hideMessages();
                        this.setState({ loaderFlag: false, createAdminUserPopup: false });
                        this.apiserve.success('Admin user created successful.');
                    }


                    break;
                case "deleteUser":
                    this.getAllAdminView(this.state.offset, this.state.perPage)
                    break;
                case "admin|updateRoleUser":
                    if(!response.error){
                        this.getAllAdminView(this.state.offset, this.state.perPage)
                    } else {
                        this.apiserve.error(response.data.error);
                    }
                    break;
                case "blockUser":
                    this.getAllAdminView(this.state.offset, this.state.perPage)
                    break;
                case "admin|updateAdmin":

                    roleWiseFilterData = []
                    this.setState({
                        createAdminUserPopup: false
                    }, () => this.getAllAdminView(this.state.offset, this.state.perPage),
                        this.clearFn(),
                        this.validator.hideMessages(),
                        this.setState({ loaderFlag: false }))
                    break;
                case "admin|searchAdmin":
                    if (response.error) {
                        this.setState({ loaderFlag: false })
                        this.apiserve.error(response.data.error ? response.data.error : response.data)
                    } else {
                        this.setState({
                            getAllDetails: response.data.docs,
                            getTotalDocs: response.data.totalDocs,
                            pageCount: Math.ceil(response.data.totalDocs / this.state.perPage),
                        }, () => {
                            this.setState({ loaderFlag: false })
                        })
                    }
                    break;
                case "loginUser":
                    if (response.error) {
                        this.apiserve.error(response.data)
                    } else {
                        let data = response.data;
                        data.user.role = localStorage.getItem('currentUserRole');
                        this.props.LoginRole(data)
                        this.props.BackToAdminFlag(true)
                        this.props.LoginAdminByID(response.data.user._id)
                        localStorage.setItem('loginToken', response.data.token)
                        // localStorage.setItem('subloginToken', response.data.token)  
                        this.apiserve.sendevent("getUser", { id: response.data.user._id });
                    }
                    break;
                case "getUser":
                    this.props.ProfileName(response.data)
                    if (response.data.additionalRoles.includes("sio") || response.data.additionalRoles.includes("press") || response.data.additionalRoles.includes("sundanceCircle") || response.data.additionalRoles.includes("sundanceGuest") || response.data.additionalRoles.includes("general") || response.data.additionalRoles.includes("artist")) {
                        this.props.getBackToAdminFlag ? this.props.history.push('/admin-dashboard') : this.props.history.push(window.location.pathname)
                    } else if (response.data.role === "partner") {
                        this.props.GetPartner(response.data)
                        this.props.history.push('/profile-partner-view')
                    } else if (response.data.role === "satellite") {
                        this.props.GetSatellite(response.data)
                        this.props.history.push('/profile-satellite-view')
                    } else if (response.data.role === "privateScreeningPartner") {
                        if (this.state.mount)
                            this.props.history.push('/partners-film-view')
                        else this.setState({ mount: true });
                    }
                    else {
                        this.props.history.push('/access-management')
                    }
                    break;
                case "admin|transferAdmin":
                    if (!response.error) {
                        this.setState({
                            deleteConfirm: false
                        })
                        let data = {
                            id: this.state.deleteId
                        }
                        this.apiserve.sendevent("deleteUser", data);
                    } else {

                    }
                    break;
                case "admin|fpgLockUnlock":

                    if (!response.error) {
                        this.setState({
                            isFpg: response.data.fpgLocked,
                        })
                    }
                    else {

                    }
                    break;
                case "admin|getCMAList":
                    if (!response.error) {
                        var cmaTreeData = this.orderWaitlistChildren(response.data);
                        var flatCMA = this.buildFlatCMA(cmaTreeData);
                        this.setState({
                            cmaTree: cmaTreeData,
                            CMA: flatCMA,
                        });
                    } else {
                        this.apiserve.error(response.data.error ? response.data.error : response.data);
                    }
                    break;
                default:
                    break;
            }
        });


        this.getAllAdminView(this.state.offset, this.state.perPage);
        this.apiserve.sendevent("admin|getCMAList", {});
        this.setState({
            loaderFlag: true,
        });
    }

    handleDeletePopup = (adminList) => {
        var emptyAdminList = []
        adminList && adminList.forEach(admin => {
            var admindata = {
                id: admin._id,
                checked: false,
                name: admin.fname + ' ' + admin.lname
            }
            emptyAdminList.push(admindata)
        });
        this.setState({
            handleDeleteArray: emptyAdminList
        })

    }


    getAllAdminView = (skip, limit, searchField, roleWiseFilterData) => {
        var data = {}
        if (this.state.searchField.length) {
            data.filter = this.state.searchField
        }
        if (roleWiseFilterData && roleWiseFilterData.length) {
            data.role = roleWiseFilterData
        }

        data.page = skip
        data.limit = limit
        this.apiserve.sendevent("admin|getAllAdmin", data);
    }

    getAllAdminDelete = (skip, limit, roleWiseFilterData) => {
        var data = {}

        if (roleWiseFilterData && roleWiseFilterData.length) {
            data.role = roleWiseFilterData
        }

        data.page = skip
        data.limit = limit
        this.apiserve.sendevent("admin|getAllAdmin", data);
    }
    // FPGlocker = () => {
    //     this.setState({
    //         FPGadminUserPopup: true,
    //         changeTitleName: false,
    //         isFpg: true
    //     })
    // }
    // blockFPGlocker = () => {
    //     this.setState({
    //         FPGadminUserBlockPopup: true,
    //         changeTitleName: false,
    //         isFpg: true
    //     })
    // }
    // closeFPGlocker = () => {
    //     this.setState({
    //         FPGadminUserBlockPopup: false,
    //     })

    // }
    FPGlocker = () => {
        this.setState({
            FPGadminUserPopup: true,
        })
    }
    closeFPGlocker = () => {
        this.setState({
            FPGadminUserPopup: false,
        })
    }
    DeleteFPGConfirm = () => {
        // if(this.props.getLoginRole.user.role === "admin"){
        // this.state.FPGtoggle=true

        this.setState({
            isFpg: !this.state.isFpg,
            FPGadminUserPopup: false,
        }, () => {

            let data = {
                fpgLocked: this.state.isFpg
            }
            this.apiserve.sendevent("admin|fpgLockUnlock", data);
            this.props.FpgLocked(this.state.isFpg)
        })

        //   this.props.FpgLocked(true)
    }
    // deleteAdminFn = () => {
    //     var admin = this.state.handleDeleteArray.find(_=>_.checked === true)
    //     if(admin)
    //     {
    //         let data = {
    //             id: admin.id,
    //             deleteId:this.state.deleteId
    //         }
    //         this.apiserve.sendevent("admin|transferAdmin", data);
    //     }
    //     else
    //     {
    //         this.apiserve.error('Please select atleast one admin user.')
    //     }

    // }

    createAdminUser = async () => {
        this.setState({
            createAdminUserPopup: true,
            changeTitleName: false,
            firstName: '',
            lastName: '',
            email: '',
            selectedDropdown: "Select an Option",
            isEdited: true
        })
    }

    closeAdminUser = () => {
        this.setState({
            deleteAdmin: false,
            deleteConfirm: false,
            createAdminUserPopup: false,
            changeTitleName: false,
            firstName: "",
            lastName: "",
            email: "",
            selectedDropdown: "Select an Option",
            CMA: this.buildFlatCMA(this.state.cmaTree),
            isEdited: false,
            initialData: null,
        });
        this.validator.hideMessages();
    }

    DeleteConfirm = () => {
        this.setState({
            deleteConfirm: true,
            deleteAdmin: false,
        }, () => {
            let roles;
            roles = [this.state.roleName];
            this.getAllAdminDelete(1, 9999, roles)
        })
    }

    onInputChange = (e) => {
        this.updateState({
            [e.target.name]: e.target.value
        });
    }

    onInputChangeDropDown = (e) => {
        this.updateState({
            [e.target.name]: e.target.value,
            selectedDropdown: e.target.value
        });
    }

    submitFn = async (e) => {
        e.preventDefault();
        if (this.validator.allValid()) {
            // Validate Product Tool rule before submit
            var finalCMA = this.state.CMA;
            var productToolEntry = finalCMA.find(function(e) { return e.access == 18; });
            var allUserEntry = finalCMA.find(function(e) { return e.access == 16; });
            if (productToolEntry && productToolEntry.value && allUserEntry) {
                finalCMA = finalCMA.map(function(entry) {
                    if (entry.access == 16) {
                        return Object.assign({}, entry, { value: true, disable: true });
                    }
                    return entry;
                });
            }

            this.setState({ loaderFlag: true, CMA: finalCMA })
            let data = {
                fname: this.state.firstName,
                lname: this.state.lastName,
                role: this.state.selectedDropdown,
                email: this.state.email,
                CMA: finalCMA
            }
            if (this.state.changeTitleName) {
                let updateData = {
                    id: this.state.id,
                    fname: this.state.firstName,
                    lname: this.state.lastName,
                    role: this.state.selectedDropdown,
                    email: this.state.email,
                    CMA: finalCMA
                }
                this.apiserve.sendevent("admin|updateAdmin", updateData);
            } else {
                this.apiserve.sendevent("admin|createAdmin", data);
            }

        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    editAdminUser = async (e, item) => {
        // Build a full baseline from the current tree (all values default false)
        var baseCMA = this.buildFlatCMA(this.state.cmaTree);

        // Overlay stored values from the user's CMA
        var mergedCMA = baseCMA.map(function(baseEntry) {
            var storedEntry = (item.CMA || []).find(function(stored) {
                return stored.access == baseEntry.access;  // loose == for string/number safety
            });
            if (storedEntry) {
                return Object.assign({}, baseEntry, { value: storedEntry.value });
            }
            return baseEntry;  // new sub-option not in DB yet — stays false
        });

        // Apply Product Tool (18) lock state on All Users (16)
        var allUserIndex = mergedCMA.findIndex(function(e) { return e.access == 16; });
        var productToolEntry = mergedCMA.find(function(e) { return e.access == 18; });
        if (allUserIndex !== -1 && productToolEntry && productToolEntry.value) {
            mergedCMA[allUserIndex] = Object.assign({}, mergedCMA[allUserIndex], {
                value: true,
                disable: true
            });
        }

        this.setState({
            createAdminUserPopup: true,
            changeTitleName: true,
            email: item.email,
            firstName: item.fname,
            lastName: item.lname,
            selectedDropdown: item.additionalRoles.filter(function(_) { return _ !== 'generalUser'; })[0],
            CMA: mergedCMA,
            id: item._id,
            isEdited: false,
        }, () => {
            this.setState({ initialData: this.getCurrentFormData(), isEdited: false });
        });
    };

    deleteAdminUser = async (item) => {
        swal({
            title: "Are you sure?",
            text: "You want to delete this record",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
        .then((willDelete) => {
            if (willDelete) {
                swal("Your record has been deleted!", {
                    icon: "success"
                });
                let data = {
                    id: item._id
                }
                this.apiserve.sendevent("deleteUser", data);
            } else {
                swal("Your record is safe!");
            }
        });
    }

    deleteAdminFn = () => {
        var admin = this.state.handleDeleteArray.find(_ => _.checked === true)
        if (admin) {
            let data = {
                id: admin.id,
                deleteId: this.state.deleteId
            }
            this.apiserve.sendevent("admin|transferAdmin", data);
        }
        else {
            this.apiserve.error('Please select atleast one admin user.')
        }

    }

    handleDeleteCheck = (e) => {

        const { name, value, checked, id } = e.target;

        var oldData = this.state.handleDeleteArray
        if (checked) {
            oldData.forEach(admin => {
                if (admin.id === id) {
                    admin.checked = true
                }
                else {
                    admin.checked = false
                }

            });
        }
        else {
            oldData.forEach(admin => {
                if (admin.id === id) {
                    admin.checked = false
                }
            });
        }

        this.setState({
            handleDeleteArray: oldData
        })
    }

    blockAdminUser = async (item) => {
        swal({
            title: "Are you sure?",
            text: "You want to block this record",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willBlock) => {
                if (willBlock) {
                    swal("Your record has been blocked!", {
                        icon: "success"
                    });
                    let data = {
                        id: item._id,
                        isBlocked: true
                    }
                    this.apiserve.sendevent("blockUser", data);
                }
            });
    }

    unblockAdminUser = async (item) => {
        swal({
            title: "Are you sure?",
            text: "You want to unblock this record",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willBlock) => {
                if (willBlock) {
                    swal("Your record has been unblock!", {
                        icon: "success"
                    });
                    let data = {
                        id: item._id,
                        isBlocked: false
                    }
                    this.apiserve.sendevent("blockUser", data);
                }
            });
    }

    clearFn = () => {
        if (this.state.changeTitleName) {
            this.getAllAdminView(this.state.offset, this.state.perPage);
            this.setState({
                firstName: "",
                lastName: "",
                CMA: this.buildFlatCMA(this.state.cmaTree),
                selectedDropdown: "Select an Option"
            });
        } else {
            this.getAllAdminView(this.state.offset, this.state.perPage);
            this.setState({
                email: "",
                firstName: "",
                lastName: "",
                CMA: this.buildFlatCMA(this.state.cmaTree),
                selectedDropdown: "Select an Option",
                isEdited: true
            });
        }
    };

    handleCMAParentChange = (e, parentItem) => {
        var newValue = e.target.checked;
        var parentAccessId = parentItem.id;
        var childAccessIds = (parentItem.children || []).map(function(child) { return child.id; });

        var updatedCMA = this.state.CMA.map(function(entry) {
            if (entry.access == parentAccessId) {
                return Object.assign({}, entry, { value: newValue });
            }
            if (childAccessIds.indexOf(entry.access) !== -1) {
                return Object.assign({}, entry, { value: newValue });
            }
            return entry;
        });
        updatedCMA = this.applyProductToolRule(updatedCMA, parentAccessId, newValue);
        this.updateState({ CMA: updatedCMA });
    };

    handleCMAChildChange = (e, childItem, parentItem) => {
        var newValue = e.target.checked;
        var updatedCMA = this.state.CMA.map(function(entry) {
            if (entry.access == childItem.id) {
                return Object.assign({}, entry, { value: newValue });
            }
            return entry;
        });
        if (newValue) {
            var parentEntry = updatedCMA.find(function(e) { return e.access == parentItem.id; });
            if (parentEntry && !parentEntry.value) {
                updatedCMA = updatedCMA.map(function(entry) {
                    if (entry.access == parentItem.id) {
                        return Object.assign({}, entry, { value: true });
                    }
                    return entry;
                });
            }
        } else {
            var childAccessIds = (parentItem.children || []).map(function(child) { return child.id; });
            var allChildrenUnchecked = childAccessIds.every(function(childId) {
                var entry = updatedCMA.find(function(e) { return e.access == childId; });
                return entry ? !entry.value : true;
            });
            if (allChildrenUnchecked) {
                updatedCMA = updatedCMA.map(function(entry) {
                    if (entry.access == parentItem.id) {
                        return Object.assign({}, entry, { value: false });
                    }
                    return entry;
                });
            }
        }
        updatedCMA = this.applyProductToolRule(updatedCMA, childItem.id, newValue);
        this.updateState({ CMA: updatedCMA });
    };

    applyProductToolRule = (cmaArray, changedAccessId, newValue) => {
        if (changedAccessId == 18) {
            var productToolEntry = cmaArray.find(function(e) { return e.access == 18; });
            return cmaArray.map(function(entry) {
                if (entry.access == 16) {
                    return Object.assign({}, entry, {
                        value: (productToolEntry && productToolEntry.value) ? true : newValue,
                        disable: (productToolEntry && productToolEntry.value) ? true : false,
                    });
                }
                return entry;
            });
        }
        return cmaArray;
    };

    ghotLoginAdmin = (item) => {
        let role = item.additionalRoles.filter(role => !USER_ROLE.map(userRole => userRole.value).includes(role))
        if(role.length > 1) {
            this.setState({loginPopup: true, loginUser: item})
        } else if(role.length === 1) {
            this.changeRouteUser(item, role[0]);
        } else {
            this.apiserve.error('No valid role found for ghost login.');
        }
    }
    
    changeRouteUser = (item, role='') => {
        let data = {
            id: item._id,
            role: role,
            isAdminLogin:true
        }
        localStorage.setItem('currentUserRole', role);
        this.props.LoginUser(this.props.getLoginRole);
        this.apiserve.sendevent("loginUser", data);
    }

    //Pagination Click
    handlePageClick = (e) => {
        const selectedPage = e.selected;
        const offset = selectedPage + 1;
        this.setState(
            {
                currentPage: selectedPage,
                offset: offset,
                loaderFlag: true
            },
            () => {
                if(roleWiseFilterData && roleWiseFilterData.length > 0) 
                    this.getAllAdminRoleFilter(offset, this.state.perPage);
                else{
                    this.getAllAdminView(offset, this.state.perPage, this.state.searchField, roleWiseFilterData);
                }
            }
        );
    };

    //role wise filter
    roleWiseFilter = (e, selectedInex) => {

        let index = selectedInex
        let event = e.target.checked

        let roleArray = [...this.state.rolesType]
        roleArray.forEach((key, i) => {
            if (index === 0) {
                if (i === 0) {
                    roleArray[index].value = event
                } else {
                    roleArray[i].value = false
                }
            } else {
                if (i === 0) {
                    if (roleWiseFilterData && roleWiseFilterData.length === 1 && !event) {
                        roleArray[i].value = true
                    } else {
                        roleArray[i].value = false
                    }
                } else {
                    roleArray[index].value = event
                }
            }


        });
        this.setState({
            ...this.state,
            rolesType: roleArray,
            currentPage: 0
        }, () => {
            if (index === 0 && event) {
                roleWiseFilterData = []
            } else if (event) {
                roleWiseFilterData = [...roleWiseFilterData, this.state.rolesType[index].assign];
            } else {
                let tempArray = roleWiseFilterData.filter((d) => d !== this.state.rolesType[index].assign);
                roleWiseFilterData = tempArray;
            }

            this.getAllAdminRoleFilter(this.state.offset, this.state.perPage);
        })
    };

    getAllAdminRoleFilter = (skip, limit) => {
        this.setState({ loaderFlag: true })
        var data = {}

        if (this.state.searchField.length) {
            data.filter = this.state.searchField
        }
        data.role = roleWiseFilterData
        data.page = 1
        data.limit = 50
        this.apiserve.sendevent("admin|searchAdmin", data);
    }

    getAdminTableHeadView = () => {
        const { rolesType } = this.state
        return (
            <tr>
                <th className="email_d">Email</th>
                <th className="firstName_d">First Name</th>
                <th className="lastName_d">Last Name</th>
                <th className="depart_d">
                    {/* Department */}


                    {/* <img src={hoverIcon} className="dot_img"/>
                    <img src={hoverIconActive} className="dot_hover_img"/> */}
                    <span className="d_flex d_flex_align_center">
                        Role
                      {roleWiseFilterData && roleWiseFilterData.length ?
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginLeft: "7px" }}>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M6 12.5C6 12.3674 6.05268 12.2402 6.14645 12.1464C6.24021 12.0527 6.36739 12 6.5 12H9.5C9.63261 12 9.75979 12.0527 9.85355 12.1464C9.94732 12.2402 10 12.3674 10 12.5C10 12.6326 9.94732 12.7598 9.85355 12.8536C9.75979 12.9473 9.63261 13 9.5 13H6.5C6.36739 13 6.24021 12.9473 6.14645 12.8536C6.05268 12.7598 6 12.6326 6 12.5ZM4 9.5C4 9.36739 4.05268 9.24021 4.14645 9.14645C4.24021 9.05268 4.36739 9 4.5 9H11.5C11.6326 9 11.7598 9.05268 11.8536 9.14645C11.9473 9.24021 12 9.36739 12 9.5C12 9.63261 11.9473 9.75979 11.8536 9.85355C11.7598 9.94732 11.6326 10 11.5 10H4.5C4.36739 10 4.24021 9.94732 4.14645 9.85355C4.05268 9.75979 4 9.63261 4 9.5ZM2 6.5C2 6.36739 2.05268 6.24021 2.14645 6.14645C2.24021 6.05268 2.36739 6 2.5 6H13.5C13.6326 6 13.7598 6.05268 13.8536 6.14645C13.9473 6.24021 14 6.36739 14 6.5C14 6.63261 13.9473 6.75979 13.8536 6.85355C13.7598 6.94732 13.6326 7 13.5 7H2.5C2.36739 7 2.24021 6.94732 2.14645 6.85355C2.05268 6.75979 2 6.63261 2 6.5Z" fill="black" />
                                <circle cx="8" cy="2" r="2" fill="black" />
                            </svg>
                            :
                            <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginLeft: "7px" }}>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4 6.5C4 6.36739 4.05268 6.24021 4.14645 6.14645C4.24021 6.05268 4.36739 6 4.5 6H7.5C7.63261 6 7.75979 6.05268 7.85355 6.14645C7.94732 6.24021 8 6.36739 8 6.5C8 6.63261 7.94732 6.75979 7.85355 6.85355C7.75979 6.94732 7.63261 7 7.5 7H4.5C4.36739 7 4.24021 6.94732 4.14645 6.85355C4.05268 6.75979 4 6.63261 4 6.5ZM2 3.5C2 3.36739 2.05268 3.24021 2.14645 3.14645C2.24021 3.05268 2.36739 3 2.5 3H9.5C9.63261 3 9.75979 3.05268 9.85355 3.14645C9.94732 3.24021 10 3.36739 10 3.5C10 3.63261 9.94732 3.75979 9.85355 3.85355C9.75979 3.94732 9.63261 4 9.5 4H2.5C2.36739 4 2.24021 3.94732 2.14645 3.85355C2.05268 3.75979 2 3.63261 2 3.5ZM0 0.5C0 0.367392 0.0526785 0.240215 0.146447 0.146447C0.240215 0.0526785 0.367392 0 0.5 0H11.5C11.6326 0 11.7598 0.0526785 11.8536 0.146447C11.9473 0.240215 12 0.367392 12 0.5C12 0.632608 11.9473 0.759785 11.8536 0.853553C11.7598 0.947321 11.6326 1 11.5 1H0.5C0.367392 1 0.240215 0.947321 0.146447 0.853553C0.0526785 0.759785 0 0.632608 0 0.5Z" fill="black" />
                            </svg>
                        }
                    </span>
                    <div className="tabelData_popup">
                        <form>
                            <div className="customCheck">
                                {rolesType.map((item, i) => (
                                    <div className="customCheckBox">
                                        <input
                                            type="checkbox"
                                            id={item.name}
                                            name={item.name}
                                            value={item.value ? true : false}
                                            checked={item.value ? true : false}
                                            onClick={(e) => this.roleWiseFilter(e, i)}
                                        />
                                        <label htmlFor={item.name}>{item.name}</label>
                                    </div>
                                ))}
                            </div>
                        </form>
                    </div>
                </th>
                <th className="regOn_d">Registered On (MT)</th>
                <th className="icon_d"></th>
            </tr>
        )
    }

    getRoleString = (roles) => {
        const roleMap = {
            general: 'General',
            sundanceGuest: 'Sundance Guest',
            sio: 'Industry',
            press: 'Press',
        };
        roles = roles.filter(role => roleMap[role]).map(role => roleMap[role]);
        if (roles.length > 0) {
            if (roles.length === 1) return roles[0];
            if (roles.length === 2) return roles.join(' & ');
            return roles.slice(0, -1).join(', ') + ' & ' + roles[roles.length - 1];
        } else  {
            return 'General';
        }
    };

    resetRole = (e, item) => {
        this.setState({roleResetPopup:true, currentUser:item})
    }

    updateRole = (user, roles) => {
        this.apiserve.sendevent("admin|updateRoleUser", {
            "userId": user._id,
            "additionalRoles" : roles
        });
        this.setState({roleResetPopup:false, currentUser:{}})
    }

    closeRoleResetPopup = () => {
        this.setState({roleResetPopup:false, currentUser:{}, loginPopup:false, loginUser:{}})
    }

    getAdminTableBodyView = () => {
        const { getAllDetails } = this.state
        return (
            getAllDetails.map((item, index) => {
                let createdAt = `${moment(item.createdAt).tz("US/Mountain").format('MM/DD/YYYY')}  ${moment(item.createdAt).tz("US/Mountain").format('h:mm A')}`;
                return (
                    <tr>
                        <td className="email_d">{item.email}</td>
                        <td className="firstName_d">{item.fname}</td>
                        <td className="lastName_d">{item.lname}</td>
                        <td className="depart_d">{this.getRoleString(item.additionalRoles)}</td>
                        {/* item.role.charAt(0).toUpperCase() + item.role.slice(1) */}
                        <td className="regOn_d">{createdAt}</td>
                        <td className="icon_d">
                            <Link onClick={(e) => this.resetRole(e, item)}>
                                <img src="/images/undo.png"  alt="revert" style={{width:"12px"}} /> <div style={{width:'120px', left:'-50px'}}>Add/Remove Role</div>
                            </Link>
                            <Link onClick={(e) => this.editAdminUser(e, item)}>
                                <img src={edit} style={{objectFit:'unset'}} /><div>edit</div>
                            </Link>
                            {item.isBlocked ?
                                <Link onClick={() => this.unblockAdminUser(item)} className="lock_icon">
                                    <LockCloseIcon /><div>unblock</div>
                                </Link>
                                :
                                <Link onClick={() => this.blockAdminUser(item)}>
                                    <LockIcon /><div>block</div>
                                </Link>
                            }

                            <Link onClick={() => this.deleteAdminUser(item)}>
                                <img src={delet} /><div>delete</div>
                            </Link>
                            <Link onClick={() => this.ghotLoginAdmin(item)}>
                                {/* <img src={share} /><div>share</div> */}
                                <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.33203 8.66668L9.66536 6.00001L6.33203 3.33334V5.33334H0.332031V6.66668H6.33203V8.66668Z" fill="#5D737E" />
                                    <path d="M7.66601 -0.000678997C6.87769 -0.00286479 6.09678 0.151395 5.3685 0.453163C4.64023 0.754932 3.97908 1.19821 3.42334 1.75732L4.36601 2.69999C5.24734 1.81865 6.41934 1.33265 7.66601 1.33265C8.91267 1.33265 10.0847 1.81865 10.966 2.69999C11.8473 3.58132 12.3333 4.75332 12.3333 5.99999C12.3333 7.24665 11.8473 8.41866 10.966 9.29999C10.0847 10.1813 8.91267 10.6673 7.66601 10.6673C6.41934 10.6673 5.24734 10.1813 4.36601 9.29999L3.42334 10.2427C4.55601 11.376 6.06267 12.0007 7.66601 12.0007C9.26934 12.0007 10.776 11.376 11.9087 10.2427C13.042 9.10999 13.6667 7.60332 13.6667 5.99999C13.6667 4.39665 13.042 2.88999 11.9087 1.75732C11.3529 1.19821 10.6918 0.754932 9.96351 0.453163C9.23524 0.151395 8.45432 -0.00286479 7.66601 -0.000678997Z" fill="#5D737E" />
                                </svg>
                                {/* <div>share</div> */}

                            </Link>
                        </td>
                    </tr>
                )
            }))
    }

    //Search Data
    onSearchFilter = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
            currentPage: 0
        }, () => {
            const role = roleWiseFilterData;
            const { searchField } = this.state;

            // clear any pending debounce timer
            clearTimeout(this._searchTimer);

            if (!searchField || searchField.length === 0) {
                const data = {
                    page: 1,
                    limit: 50,
                    role
                };
                this.apiserve.sendevent("admin|getAllAdmin", data);
                return;
            }

            const data = {
                page: 1,
                limit: 50,
                filter: searchField,
                role
            };

            // debounce the API call by 500ms
            this._searchTimer = setTimeout(() => {
                this.apiserve.sendevent("admin|getAllAdmin", data);
            }, 500);
        });
    }

    render() {
        this.validator.purgeFields();
        const { createAdminUserPopup, CMA, cmaTree, getAllDetails, changeTitleName, getTotalDocs, handleDeleteArray, FPGadminUserPopup, FPGadminUserBlockPopup } = this.state
        return (
            <React.Fragment>
                {/* <MainLayout history={this.props.history}> */}
                <div className="right_side_wrapper">
                    <div className="dashboard_header with_btn">
                        <div className="searchBlock">
                            {/* <span>All Users ( {getTotalDocs} )</span> */}
                            <span>Admin Users ({getTotalDocs})</span>
                            <form onSubmit={e => { e.preventDefault(); }}>
                                <input
                                    type="text"
                                    placeholder="Search"
                                    id="searchField"
                                    name="searchField"
                                    value={this.state.searchField}
                                    onChange={this.onSearchFilter} />
                                <button type='button' style={{ pointerEvents: 'none' }}>
                                    <img src={serachIcon} />
                                </button>
                            </form>
                        </div>
                        <div className="FPGsearchBlock ">
                            <div className="button_block FPG_btn">

                                <Link onClick={() => this.FPGlocker()}
                                    className="head_btn">
                                    <div className="Lock">
                                        {this.props.FpgLockeded ? <img src={lockIcon} /> : <img src={lock} />}
                                    </div>  {this.props.FpgLockeded ? "FPG Locked" : "FPG UnLocked"}
                                </Link>

                                {/* <Link onClick={() => this.FPGlocker()}  className="head_btn">
                                <div className="Lock"> 
                                </div> FPG Locked 
                            </Link> */}

                                {/* <Link onClick={() => this.FPGlocker()}
                                    className="head_btn">
                                 <div className="Lock"> <img src={lockIcon} /></div>  FPG Locked 
                                </Link> */}
                            </div>
                            <div className="button_block">
                                <Link onClick={() => this.createAdminUser()}
                                    className="head_btn">
                                    Create Admin User
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="dashboard_data">
                        <div className="dashboard_data_table film_list_table striped_table">
                            <table>
                                <thead>
                                    {this.getAdminTableHeadView()}
                                </thead>
                                <tbody>
                                    {this.getAdminTableBodyView()}
                                </tbody>
                            </table>
                        </div>

                        {/* Pagination View Display */}

                        {getAllDetails.length && getAllDetails ? (
                            <div className="custom-pagination">
                                <ReactPaginate
                                    previousLabel={""}
                                    nextLabel={""}
                                    breakLabel={"..."}
                                    breakClassName={"break-me"}
                                    pageCount={this.state.pageCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    onPageChange={this.handlePageClick}
                                    containerClassName={"pagination"}
                                    subContainerClassName={"pages pagination"}
                                    activeClassName={"active"}
                                    forcePage={this.state.currentPage}
                                />
                            </div>
                        ) : (
                                ""
                            )}

                    </div>
                </div>

                {FPGadminUserPopup ?
                    <div className="delete_popup_wrapper">
                        {/* <span className="popup_overlay"></span> */}
                        <div className="popup_inner">
                            <h2 className="popup_title text_center relative">
                                FPG Lock
                             <img src={close} onClick={() => this.closeFPGlocker()} />
                            </h2>
                            <div className="details">
                                <h3 className="detail_title text_center">{this.state.isFpg ? "Are you sure you want to UNLOCK the FPG?" : "Are you sure you want to LOCK the FPG?"}</h3>
                                <div className="content_management">
                                    <div className="field_row text_center">
                                        <button className="grayBTN"
                                            type="button"
                                            onClick={() => this.DeleteFPGConfirm()}
                                        >YES</button>
                                        <button className="orangeBTN active"
                                            type="button"
                                            onClick={(e) => this.closeFPGlocker(e)}>NO</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    : ""}
                {createAdminUserPopup ?
                    <div className="popup_wrapper">
                        <h2>
                            {changeTitleName ? "Edit Admin User" : "Create New Admin User"}
                            <img src={close} onClick={() => this.closeAdminUser()} />
                        </h2>
                        <form>
                            <div className="details">
                                <div className="form_group">
                                    <label>Email</label>
                                    <div className="form_group_input">
                                        <input
                                            type="email"
                                            name="email" id="email"
                                            disabled={this.state.changeTitleName ? true : false}
                                            maxLength={255}
                                            value={this.state.email}
                                            onChange={this.onInputChange}
                                        />
                                        <span style={{ color: 'red' }}>{this.validator.message('Email', this.state.email, 'required|email')}</span>
                                    </div>
                                </div>

                                <div className="form_group">
                                    <label>First Name</label>
                                    <div className="form_group_input">
                                        <input type="text" name="firstName" id="firstName"
                                            value={this.state.firstName}
                                            onChange={this.onInputChange}
                                            maxLength={100}
                                        />
                                        <span style={{ color: 'red' }}>{this.validator.message('first name', this.state.firstName, 'required|apostrophe')}</span>
                                    </div>
                                </div>

                                <div className="form_group">
                                    <label>Last Name</label>
                                    <div className="form_group_input">
                                        <input type="text" name="lastName" id="lastName"
                                            value={this.state.lastName}
                                            onChange={this.onInputChange}
                                            maxLength={100}
                                        />
                                        <span style={{ color: 'red' }}>{this.validator.message('last name', this.state.lastName, 'required|apostrophe')}</span>
                                    </div>
                                </div>

                                {!changeTitleName && <div className="form_group">
                                    <label>Department</label>
                                    <div className="form_group_control">
                                        <div className="form_group_input form_group_select">
                                            <select
                                                value={this.state.selectedDropdown}
                                                className="custom"
                                                name={this.state.selectedDropdown}
                                                id='role'
                                                onChange={this.onInputChangeDropDown}
                                            >
                                                {/* <option disabled selected>Select an Option</option> */}
                                                {this.state.roleType.map((e, key) => {
                                                    return <option key={key} value={e.value} disabled={e.value === 'Select an Option'} selected={e.value === this.state.selectedDropdown}>{e.name}</option>;
                                                    // <option key={key} value={e.value}>{e.name}</option>;
                                                })}
                                            </select>
                                        </div>
                                        <span style={{ color: 'red' }}>{this.validator.message('partner type', this.state.selectedDropdown === 'Select an Option' ? '' : this.state.selectedDropdown, 'required')}</span>
                                        {/* <span style={{ color: 'red' }}>{this.validator.message('role', this.state.role, 'required')}</span> */}
                                    </div>
                                </div>}
                            </div>

                            <div className="content_management">
                                <h2>Content Management Access</h2>
                                <div className="customCheck">
                                    {(cmaTree || []).map((parentItem, parentIndex) => {
                                        var parentCMAEntry = CMA.find(function(c) { return c.access == parentItem.id; });
                                        var parentChecked = parentCMAEntry ? parentCMAEntry.value : false;
                                        var parentDisabled = parentCMAEntry ? !!parentCMAEntry.disable : false;

                                        var hasChildren = parentItem.children && parentItem.children.length > 0;
                                        var childEntries = hasChildren
                                            ? parentItem.children.map(function(child) {
                                                return CMA.find(function(c) { return c.access == child.id; }) || { access: child.id, value: false };
                                              })
                                            : [];
                                        var someChildChecked = childEntries.some(function(c) { return c.value; });
                                        var allChildrenChecked = childEntries.length > 0 && childEntries.every(function(c) { return c.value; });
                                        var isPartial = hasChildren && someChildChecked && !allChildrenChecked;

                                        return (
                                            <div key={"parent-" + parentItem.id} className="customCheckGroup" style={{paddingLeft: parentItem.id === 26 ? '20px' : '0px'}}>
                                                <div className="customCheckBox">
                                                    <input
                                                        type="checkbox"
                                                        id={"cma-parent-" + parentItem.id}
                                                        checked={parentChecked ? true : false}
                                                        disabled={parentDisabled}
                                                        className={isPartial ? "partial" : ""}
                                                        onClick={(e) => this.handleCMAParentChange(e, parentItem)}
                                                    />
                                                    <label htmlFor={"cma-parent-" + parentItem.id}>
                                                        {parentItem.label}
                                                    </label>
                                                </div>
                                                {hasChildren && (
                                                    <div className="customCheckChildren" style={{ paddingLeft: '20px' }}>
                                                        {parentItem.children.map((childItem, childIndex) => {
                                                            var childCMAEntry = CMA.find(function(c) { return c.access == childItem.id; });
                                                            var childChecked = childCMAEntry ? childCMAEntry.value : false;
                                                            return (
                                                                <div key={"child-" + childItem.id} className="customCheckBox">
                                                                    <input
                                                                        type="checkbox"
                                                                        id={"cma-child-" + childItem.id}
                                                                        checked={childChecked ? true : false}
                                                                        onClick={(e) => this.handleCMAChildChange(e, childItem, parentItem)}
                                                                    />
                                                                    <label htmlFor={"cma-child-" + childItem.id}>
                                                                        {childItem.label}
                                                                    </label>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                                <div className="btn_wrapper">
                                    <button className="grayBTN"
                                        type="button"
                                        onClick={() => this.clearFn()}
                                    >Clear</button>
                                    <button className="orangeBTN"
                                        type="button"
                                        disabled={!this.state.isEdited}
                                        onClick={(e) => this.submitFn(e)}>Submit</button>
                                </div>
                            </div>


                        </form>
                    </div>
                    : ''}

                {
                    this.state.deleteAdmin ?
                        <div className="delete_popup_wrapper">
                            {/* <span className="popup_overlay"></span> */}
                            <div className="popup_inner">
                                <h2 className="popup_title text_center relative">
                                    Delete Admin User
                                        <img src={close} onClick={() => this.closeAdminUser()} />
                                </h2>
                                <div className="details">
                                    <h3 className="detail_title text_center">Are you sure you want to delete this Admin User?</h3>
                                    <div className="content_management">
                                        <div className="field_row text_center">
                                            <button className="grayBTN"
                                                type="button"
                                                onClick={() => this.DeleteConfirm()}
                                            >YES</button>
                                            <button className="orangeBTN active"
                                                type="button"
                                                onClick={(e) => this.closeAdminUser(e)}>NO</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        : ''
                }
                {
                    this.state.deleteConfirm ?
                        <div className="delete_popup_wrapper">
                            {/* <span className="popup_overlay"></span> */}
                            <div className="popup_inner">
                                <h2 className="popup_title text_center relative">
                                    Delete Admin User
                                        <img src={close} onClick={() => this.closeAdminUser()} />
                                </h2>
                                <div className="details_top">
                                    <p className="text_center">You are about to delete an Admin User who has users subscribed to the SFF platform. </p>
                                    <h3 className="detail_title text_center">Who do you want to assign those users to?</h3>

                                </div>
                                <div className="bg_title">
                                    <h3 className="detail_title">Available Admin Users ({this.state.roleName === 'sio' ? 'Industry'
                                        : this.state.roleName === 'press' ? 'Press'
                                            : this.state.roleName === 'sundanceCircle' ? 'Sundance Circle'
                                                : this.state.roleName === 'sundanceGuest' ? 'Sundance Guest'
                                                    : this.state.roleName === 'general' ? 'General'
                                                        : this.state.roleName === 'artist' ? 'Artist' : ''})</h3>
                                </div>
                                <div className="details">
                                    <div className="detail_check_wrap">
                                        {handleDeleteArray.map((data) => (
                                            data.id === this.state.deleteId ?
                                                ''
                                                :
                                                // <CheckBox type="radio" label={data.fname} value={data.fname} name={data.fname} id={data.fname} onChange={this.onChange} />
                                                <CheckBox
                                                    name={data.name}
                                                    label={data.name}
                                                    checked={data.checked}
                                                    value={data.name}
                                                    onChange={this.handleDeleteCheck}
                                                    type="checkbox"
                                                    id={data.id}
                                                />

                                        ))}

                                        {/* <CheckBox type="radio" label="Peter Furrough" value="furrough" name="industry" id="furrough" onChange={this.onChange} /> */}
                                    </div>

                                    <div className="content_management">
                                        <div className="field_row text_center mb_0">
                                            <button className="grayBTN"
                                                type="button"
                                                onClick={() => this.closeAdminUser()}
                                            >CANCEL</button>
                                            <button className="orangeBTN active"
                                                type="button"
                                                onClick={(e) => this.deleteAdminFn(e)}>SUBMIT</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        ''
                }
                {this.state.roleResetPopup && <RoleResetPopup closeRoleResetPopup={this.closeRoleResetPopup} user={this.state.currentUser} admin={true} updateRole={this.updateRole} />}
                {this.state.loginPopup && <GhostLoginPopup closePopup={this.closeRoleResetPopup} user={this.state.loginUser} ghostLogin={this.changeRouteUser} />}
                {/* </MainLayout> */}
                {/* Loader */}
                {this.state.loaderFlag ? (
                    <Loader />
                ) : (
                        ""
                    )}
            </React.Fragment>
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(superAdminAccessMgnt)